import { useMutation } from "@tanstack/react-query";
import { downloadService } from "@/services/downloadService";

export type DirectFileDownloadParams = {
  fileUrl: string;
  fileName: string;
};

type UseDirectFileDownloadOptions = {
  onSuccess?: (variables: DirectFileDownloadParams) => void;
  onError?: (error: Error, variables: DirectFileDownloadParams) => void;
};

export const useDirectFileDownload = (
  options?: UseDirectFileDownloadOptions,
) => {
  const mutation = useMutation({
    mutationFn: async ({ fileUrl, fileName }: DirectFileDownloadParams) => {
      await downloadService.downloadFileFromUrl(fileUrl, fileName);
      return { fileName };
    },
    onSuccess: (_data, variables) => {
      options?.onSuccess?.(variables);
    },
    onError: (error: Error, variables) => {
      console.error("Direct file download failed:", error);
      options?.onError?.(error, variables);
    },
  });

  return {
    downloadFile: mutation.mutate,
    downloadFileAsync: mutation.mutateAsync,
    isDownloading: mutation.isPending,
    error: mutation.error,
  };
};
